export const ConvertStringToArray = (value) => {
    if (typeof value === 'string' && value.includes(',')) {
        return value.split(',').map(item => item.trim());
    } else {
        return [value];
    }
};